// components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { CreateResourceDrawer } from './components/CreateResourceDrawer/CreateResourceDrawer';

// utils
import { queries } from 'RestAPIs/rapini';

// hooks
import { useColumnDefinitions } from './Resources.utils';

const Resources = () => {
  const {
    data: resources,
    isLoading,
    isError,
    refetch
  } = queries.useFindResources();

  const columns = useColumnDefinitions();

  return (
    <TableCRUDLayout
      loading={isLoading}
      columns={columns}
      FormComponent={CreateResourceDrawer}
      onClose={refetch}
      rows={resources}
      getRowId={(resource) => resource.id!}
      hasLoadingError={isError}
      onLoadingError={refetch}
    />
  );
};

export default Resources;
